import { render, staticRenderFns } from "./SMSSettings.vue?vue&type=template&id=3998cf04&scoped=true"
import script from "./SMSSettings.vue?vue&type=script&lang=js"
export * from "./SMSSettings.vue?vue&type=script&lang=js"
import style0 from "./SMSSettings.vue?vue&type=style&index=0&id=3998cf04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998cf04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3998cf04')) {
      api.createRecord('3998cf04', component.options)
    } else {
      api.reload('3998cf04', component.options)
    }
    module.hot.accept("./SMSSettings.vue?vue&type=template&id=3998cf04&scoped=true", function () {
      api.rerender('3998cf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/SMSSettings.vue"
export default component.exports